import { IAttributeRow, IInstance, IKnowladgeGraphDifferences, IKnowladgeGraphDifferencesRow, IKnowladgeGraphInstance } from '../../../../../../../interface/interfaces';

const transformData = (rowData: IKnowladgeGraphDifferencesRow): IKnowladgeGraphDifferences => {
    const allInstances = [...rowData.new_instances, ...rowData.changed_instances];

    const instances: IKnowladgeGraphInstance[] = allInstances
        .map((instance: IInstance) =>
            instance.attributes.map((attr: IAttributeRow) => ({
                id: instance.id,
                name: instance.name,
                type: instance.type,
                attribute_name: attr.name,
                old: attr.old,
                new: attr.new,
                priority: attr.priority,
                overwritten: attr.overwritten,
                user_id: attr.user_id,
                comment: attr.comment,
            })),
        )
        .flat();

    return {
        metadata: rowData.metadata,
        instances,
    };
};

export const finalData = (data: IKnowladgeGraphDifferencesRow): IKnowladgeGraphInstance[] => {
    const transformedData = transformData(data);

    const addStatusProperty = transformedData.instances.map((instance: IKnowladgeGraphInstance) => {
        return { ...instance, status: instance.old ? 'Changed' : 'New' };
    });

    return addStatusProperty;
};
